import ErrorMessage404 from '@/views/Public/ErrorMessage404.vue'
import { createRouter as _createRouter, createWebHistory } from 'vue-router'
import { captureEvent } from '@sentry/browser'
import brandedRoutes from './routes/branded'
import businessRoutes from './routes/business'
import portalRoutes from './routes/portal'
import publicRoutes from './routes/public'
import { useAuthStore } from '@/pinia/auth'
import { useStyleStore } from '@/pinia/style'

const routes = [
  ...filter_routes([...publicRoutes, ...brandedRoutes, ...portalRoutes, ...businessRoutes]),
  {
    name: '404',
    path: '/:pathMatch(.*)*',
    component: ErrorMessage404,
    beforeEnter: (to, from, next) => {
      if (from?.name) {
        captureEvent({
          message: `Status 404 - ${to?.fullPath}`,
          tags: {
            status: 404
          }
        })
      }
      next()
    }
  }
]

function filter_routes(routes) {
  const installation = import.meta.env.VITE_APP_INSTALLATION_TYPE
  if (installation === 'business') {
    return routes.filter((x) => x.meta.app !== 'customer' && x.meta.app !== 'branded')
  } else if (installation === 'portal') {
    return routes.filter((x) => x.meta.app !== 'staff')
  } else {
    return routes
  }
}

export function createRouter() {
  const router = _createRouter({
    history: createWebHistory(),
    base: import.meta.env.BASE_URL,
    routes
  })

  router.beforeEach(async (to, from, next) => {
    if (to.name === '404') {
      next()
      return
    }
    const authStore = useAuthStore()
    // Require login, and limit branded guest sessions to branded routes.
    const canAccessRoute = authStore.loggedIn && (authStore.installation !== 'branded' || to.meta.app === 'branded')
    if (canAccessRoute || to.meta.app === 'public') {
      next()
    } else if (to.meta.app === 'branded') {
      next({ path: `/launch/${to.params.slug}` })
    } else {
      next({
        path: '/logout',
        query: {
          path: authStore.login_url,
          redirect: to.fullPath
        }
      })
    }
  })

  router.afterEach((to) => {
    const styleStore = useStyleStore()
    styleStore.setPageName(to.name)
  })

  return router
}
